"use strict";

import getNgModule from "getNgModule";
const ngModule = getNgModule(__filename);

ngModule.directive("obsEpciMapTooltip", function(obsUtils) {
    return {
        restrict : "E",
        require  : "^obsEpciManager",
        scope    : true,
        replace  : true,
        template : `
        <div class="leaflet-control control obs-map-tooltip">
            <div class="hovered-name">{{hoverName}}</div>
            <div class="hovered-value">
                {{referenceLabel}}: {{hoverValue}}
            </div>
        </div>`,
        link : function($scope, $el, $attrs, managerCtrl) {
            $scope.$watch(() => managerCtrl.getHoveredEpci(), (epci) => {
                if (epci == null) {
                    $scope.hoverName = null;
                    $scope.hoverValue = null;
                } else {
                    $scope.hoverName = epci.nom;
                    $scope.hoverValue = obsUtils.formatValue($scope.epciParams, epci.value);
                }
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/maps/epci/obsEpciMapTooltip.js